import { render, staticRenderFns } from "./InternetRenewalTable.vue?vue&type=template&id=77c20cd8&scoped=true"
import script from "./InternetRenewalTable.vue?vue&type=script&lang=js"
export * from "./InternetRenewalTable.vue?vue&type=script&lang=js"
import style0 from "./InternetRenewalTable.vue?vue&type=style&index=0&id=77c20cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c20cd8",
  null
  
)

export default component.exports